import { getCookie } from '@buddieshr/utils/utils';
import { useRouter } from 'next/router';
import { useEffect } from 'react';

const SimpleperfRegister = () => {
  const router = useRouter();

  useEffect(() => {
    if (!router.isReady) return;

    const ref = router.query.ref || 'landing_buddieshr';
    let url = `https://dashboard.buddieshr.com/#/register?ref=${ref}`;

    const gacid = getCookie('_ga')?.slice(6);
    const gclid = localStorage.getItem('gclid');
    const fbclid = localStorage.getItem('fbclid');
    if (gacid) url += `&gacid=${gacid}`;
    if (gclid) url += `&gclid=${gclid}`;
    if (fbclid) url += `&fbclid=${fbclid}`;

    window.location.href = url;
  }, [router.isReady]);

  return null;
};

export default SimpleperfRegister;
